import React from "react";
import abierto from "../../media/Icon-ChevronLeft12-White.svg";
import "./menu.css";
import { withRouter } from "react-router";

class MenuSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: props.opciones,
      menuAbierto: true,
      fecha: props.fecha,
    };
  }

  abrirCerrarMenu() {
    this.setState({ menuAbierto: !this.state.menuAbierto });
  }

  cambiaPantalla(url) {
    this.props.history.push(url);
  }

  render() {
    let menuAbierto = this.state.menuAbierto === true ? "abierto" : "cerrado";
    return (
      <React.Fragment>
        <div
          className={`form__container--ayuda-icon ${menuAbierto}`}
          onClick={() => {
            this.abrirCerrarMenu();
          }}
        >
          <div className="form__container--ayuda-menu">
            <img src={abierto} alt="abierto" />
          </div>
        </div>
        <div className={`sidebar ${menuAbierto}`}>
          <div className="form_container--ayuda-menu-contenido">
            {this.state.opciones.map((opcion, i) => {
              return (
                <div
                  key={"opcion-menu-" + i}
                  className={
                    opcion.titulo !== "Inicio"
                      ? "pt-2 pb-2 form_container--ayuda-menu-contenido-l"
                      : "pt-2 pb-2 form_container--ayuda-menu-contenido-l inicio"
                  }
                  onClick={() => {
                    this.cambiaPantalla(opcion.url);
                  }}
                >
                  {opcion.titulo}
                </div>
              );
            })}
          </div>
        </div>
        <div className={`form__container--ayuda-actualizacion ${menuAbierto}`}>
          Última actualización: <br /> {this.state.fecha}
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(MenuSidebar);
